import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AccountOnboardingService } from '../../services/authentication/accountOnboardingService';

export const useStripeAccountOnboarding = () => {
  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const onboardingExited = false;
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [connectedAccountId, setConnectedAccountId] = useState<string | undefined>();
  const isCompletedRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user came from organization creation page
  useEffect(() => {
    const fromOrgCreate = sessionStorage.getItem('fromOrgCreate');
    if (!fromOrgCreate) {
      navigate('/auth');
      return;
    }

    // Handle page refresh
    const handleBeforeUnload = () => {
      if (connectedAccountId && !isCompletedRef.current) {
        // AccountOnboardingService.deleteStripeAccount(connectedAccountId);
      }
      sessionStorage.removeItem('fromOrgCreate');
      sessionStorage.removeItem('orgCreationData');
      navigate('/auth');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location, navigate, connectedAccountId]);

  // Cleanup function to delete account when component unmounts
  useEffect(() => {
    return () => {
      if (connectedAccountId && !isCompletedRef.current) {
        // AccountOnboardingService.deleteStripeAccount(connectedAccountId);
      }
    };
  }, [connectedAccountId]);

  const handleStartSetup = async () => {
    try {
      setAccountCreatePending(true);
      const accountId = await AccountOnboardingService.createStripeAccount();
      setConnectedAccountId(accountId);
      await AccountOnboardingService.createAccountSession(accountId);
    } catch (error) {
      console.error('Error:', error);
      setError(error instanceof Error ? error.message : 'An unknown error occurred');
      if (connectedAccountId) {
        // AccountOnboardingService.deleteStripeAccount(connectedAccountId);
      }
    } finally {
      setAccountCreatePending(false);
    }
  };

  const handleQuit = () => {
    if (!onboardingCompleted && connectedAccountId) {
      // AccountOnboardingService.deleteStripeAccount(connectedAccountId);
    }
    sessionStorage.removeItem('fromOrgCreate');
    sessionStorage.removeItem('orgCreationData');
    navigate('/auth');
  };

  const handleOnboardingComplete = () => {
    isCompletedRef.current = true;
    setOnboardingCompleted(true);
  };

  return {
    accountCreatePending,
    onboardingExited,
    onboardingCompleted,
    error,
    connectedAccountId,
    isCompletedRef,
    handleStartSetup,
    handleQuit,
    handleOnboardingComplete,
    setError
  };
}; 